import { Component, OnInit } from "@angular/core";

@Component({
    templateUrl: './base.component.html',
    standalone: false
})

export class BaseComponent {

}
